<div class="order-summary--totals" *ngIf="order">
    <div class="order-summary--totals__header">
        <h2 class="m-0">{{title}} ({{order.items.length}} {{order.items.length === 1 ? ' item' : ' items'}})</h2>
    </div>
    <div  class="order-summary--totals__body">
        <div class="my-3">
            <span class="uppercase font-4">Subtotal</span>
            <span class="price font-weight-normal font-2"><app-currency-price [price]="order.subTotal" [currency]="order.currency"></app-currency-price></span>
        </div>
        <div class="my-3">
            <span class="uppercase font-4">Estimated Shipping&nbsp;<i class="fal fa-info-circle" ngbTooltip="{{shippingInfo}}"  placement="{{ tooltipPosition }}" tooltipClass="tooltips"></i></span>
            <span class="price font-weight-normal font-2"><app-currency-price [price]="order.shippingTotal" [currency]="order.currency"></app-currency-price></span>
        </div>
        <div class="mt-3 pb-2" [ngClass]="{'color-red' : taxExemptOrderHasTaxes}">
            <span class="uppercase font-4">Taxes&nbsp;<i *ngIf="taxExemptOrderHasTaxes" class="fal fa-info-circle" ngbTooltip="{{taxExemptInfo}}"   placement="{{ tooltipPosition }}" tooltipClass="tooltips"></i></span>
            <span class="price font-weight-normal font-2"><app-currency-price [price]="order.taxes" [currency]="order.currency"></app-currency-price></span>
        </div>

        <ng-container *ngIf="order.discountTotal > 0 || order.budgetTotal > 0">

            <div class="mt-3 line-separator--grey"></div>

            <div *ngIf="order.discountTotal > 0"  class="my-3">
                <span class="uppercase font-4">Discounts</span>
                <span class="price green font-weight-normal font-2">-<app-currency-price [price]="order.discountTotal" [currency]="order.orderCurrency"></app-currency-price></span>
            </div>

            <div *ngIf="order.budgetTotal > 0" class="my-3">
                <a href="#" class="link link-underline uppercase font-4 font-weight-normal" (click)="showBudgetDetails()">Budget Applied&nbsp;<i class="fas fa-exclamation-circle"></i></a>
                &nbsp;<span class="price green font-weight-normal font-2">-<app-currency-price [price]="order.budgetTotal" [currency]="order.orderCurrency"></app-currency-price></span>
            </div>


        </ng-container>
        <div style="flex: 1 1"></div>
        <div class="line-separator--grey"></div>
        <div class="my-3">
            <span class="uppercase font-4 font-weight-bold">Total</span>
            <span class="price font-1"><app-currency-price [price]="order.totalCost" [currency]="order.currency"></app-currency-price></span>
        </div>

    </div>
</div>
